export default "__VITE_ASSET__CmBnGAC3__"